import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.less';
import App from './App';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  // Ant Designs is giving a warning when using Strict Mode
  // <React.StrictMode>
  <React.Suspense fallback="">
    <App />
  </React.Suspense>,
  // </React.StrictMode>
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
